<fgb-lottos-page></fgb-lottos-page>
